<template>
  <div class="ver-info-dialog">
    <el-dialog
      :before-close="onClose"
      title="版本信息"
      v-model="verInfoDialogVisible"
      width="80%"
      top="10vh"
      center
    >
      <div class="_item" style="padding-top: 10px;">
        <span>
         产品名称 : {{projectVersion.filmName}}
        </span>
      </div>
       <div class="_item">
        <span>
         规格型号 : {{projectVersion.filmModel}}
        </span>
      </div>
       <div class="_item">
        <span>
         发布版本号 : {{projectVersion.filmReleaseVersion}}
        </span>
      </div>
       <div class="_item">
        <span>
         完整版本号 : {{projectVersion.filmCompleteVersion}}
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//tags
import { mapGetters } from "vuex"
export default {
  data() {
    return {}
  },
  computed: { ...mapGetters(["projectVersion"]) },
  props: {
    verInfoDialogVisible: {
      type: Boolean
    }
  },
  methods: {
    onClose() {
      this.$parent.verInfoDialogVisible = false
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "text-align:center;background-color:#fff;height:40px; padding: 0px;"
      }
    }
  },
  mounted() {}
}
</script>
<style lang="scss" scoped>
.ver-info-dialog {
  :deep(.el-dialog__headerbtn) {
    top: 10px;
    right: 10px;
    width: 16px;
    height: 16px;
  }
  :deep(.el-dialog__header) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}
</style>
